import React from "react";
import type { ProductUI } from "@/shared/types";
import {
  getLineTotal,
  getQuantityUnit,
  isFishProduct,
  resolveProductPrice,
} from "@/shared/utils/productPricing";
import "./styles/ProductPrice.scss";

interface ProductPriceDisplayProps {
  product: ProductUI;
  quantity?: number;
  className?: string;
  showWholesale?: boolean;
  showPerFishHint?: boolean;
}

export const ProductPriceDisplay: React.FC<ProductPriceDisplayProps> = ({
  product,
  quantity = 1,
  className = "",
  showWholesale = true,
  showPerFishHint = true,
}) => {
  const pricing = resolveProductPrice(product, quantity);
  const unit = getQuantityUnit(product);

  if (isFishProduct(product) && pricing.pricePerKg != null) {
    const perFish = pricing.unitPrice;
    return (
      <div className={className}>
        <div className="product-price__main">
          <span className="product-price__value">
            {pricing.pricePerKg.toLocaleString("ru-RU")} ₽/кг
          </span>
          {showWholesale && pricing.wholesaleLabel && (
            <span className="product-price__wholesale">{pricing.wholesaleLabel}</span>
          )}
        </div>
        {showPerFishHint && (
          <div className="product-price__secondary">
            {perFish.toLocaleString("ru-RU")} ₽/{unit}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="product-price__main">
        <span className="product-price__value">
          {pricing.unitPrice.toLocaleString("ru-RU")} ₽/{unit}
        </span>
        {showWholesale && pricing.wholesaleLabel && (
          <span className="product-price__wholesale">{pricing.wholesaleLabel}</span>
        )}
      </div>
    </div>
  );
};

interface ProductLineTotalProps {
  product: ProductUI;
  quantity: number;
  className?: string;
}

export const ProductLineTotal: React.FC<ProductLineTotalProps> = ({
  product,
  quantity,
  className = "",
}) => {
  return (
    <span className={className}>
      {getLineTotal(product, quantity).toLocaleString("ru-RU")} ₽
    </span>
  );
};
